module.exports = __webpack_public_path__ + "img/Pic_Text_GYY_Down.01613bc7.png";